/* unplugin-vue-components disabled */import { render } from "./chat.vue?vue&type=template&id=3f09952a&scoped=true"
import script from "./chat.vue?vue&type=script&lang=js"
export * from "./chat.vue?vue&type=script&lang=js"

import "./chat.vue?vue&type=style&index=0&id=3f09952a&lang=stylus&scoped=true"

import exportComponent from "/data/jenkins_home/workspace/JOINMC-H5-HTML-MASTER/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f09952a"]])

export default __exports__